import { BaseApiClient } from '../BaseApiClient'

export class DaData extends BaseApiClient {
  static async dadataSuggest (method, query, data = {}) {
    const bodyData = {
      query,
      ...data
    }

    return this.post(`dadata/suggest/${method}`, bodyData, {
      headers: this.getAuthHeaders()
    })
  }

  static async suggestFio (query, data = {}) {
    return this.dadataSuggest('fio', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async suggestAddress (query, data = {}) {
    return this.dadataSuggest('address', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async suggestParty (query, data = {}) {
    return this.dadataSuggest('party', query, data)
      .then(response => response.data ? response.data.data : null)
  }
}
